import { $http } from '../request'

export type CpsShareLandingStatus = 'relationship_established' | 'view_only'

export interface CpsShareLandingData {
  coupon?: {
    amount?: number | string | null
    minimumBillAmount?: number | string | null
  } | null
  status: CpsShareLandingStatus
  listingId: number
  pathToken: string | null
  relationshipExpiresAt: string | null
}

export interface CpsShareLandingResponse {
  code: number
  data: CpsShareLandingData
  msg: string
}

export const resolveCpsShareLanding = (
  assetId: string,
  pathToken?: string
): Promise<CpsShareLandingResponse> => $http.post({
  url: `/marketing/v1/cps/share-landings/${assetId}`,
  body: pathToken ? { pathToken } : {},
  server: true,
  toastError: false,
  rejectBusinessError: true
})
